import { trackInstanciedThirdLevelMenuItem } from "../googleAnalytics/primaryMenuItemTracking";
import MenuService from "./menuService";

$(() => {
    initializeMegaMenus()
});

function initializeMegaMenus() {
    $("[data-mega-menu]").each(function () {
        new MegaMenu(this);
    });
}

class MegaMenu {
    el: JQuery<HTMLElement>;
    hasLoadedGrandChildren = false;
    isLoadingGrandChildren = false;
    thirdLevelFirstColumnMax = null;
    thirdLevelSecondColumnMax = null;
    loadedChildren: { isLoading: boolean, isSuccessful: boolean, el: HTMLElement }[] = [];


    constructor(megaMenu: HTMLElement) {
        this.el = $(megaMenu);
        this.thirdLevelFirstColumnMax = megaMenu.dataset.thirdLevelFirstColumnMax;
        this.thirdLevelSecondColumnMax = megaMenu.dataset.thirdLevelSecondColumnMax;
        const self = this;
        const elements = this.el.find(".mega-menu-list-item").toArray();
        this.loadedChildren = elements.map(el => {
            return {
                isLoading: false,
                isSuccessful: false,
                el
            }
        });
        this.el.siblings("[data-mega-menu-activator]").on("mouseenter", function () {
            self.loadGrandChildren();
        });
    }

    /**
     * Will iterate over loadedChildren and try to load grand children if possible
     */
    async loadGrandChildren() {
        const elements = Object.values(this.loadedChildren).filter(c => !c.isLoading && !c.isSuccessful);

        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            this.loadSpecificGrandChildren(element);
        }
    }

    async loadSpecificGrandChildren(children: { isLoading: boolean, isSuccessful: boolean, el: HTMLElement }) {
        const element = children.el;
        const contentId = parseInt(element.dataset.contentId);

        try {
            children.isLoading = true;
            element.classList.add("is-loading");

            const node = await MenuService.getNavigationNode(contentId);

            if (node.children.length && node.childrenLoaded) {
                element.classList.add("has-children");

                let childrenHtml = [];

                node.children.forEach((node) => {
                    if (!node.hideFromTopMenu == true)
                    {
                        childrenHtml.push(`
                        <li class="mega-menu-sublist-item">
                            <a class="mega-menu-sublist-item-link" href="${node.friendlyUrl}" menu-item-link-primary-level-3="">${node.name}</a>
                        </li>
                    `);
                    }
                });

                let childrenContainer = [];

                childrenContainer.push(`
                    <ul class="col-md-6 no-bullet">
                        ${childrenHtml.slice(0, this.thirdLevelFirstColumnMax).join("")}
                    </ul>
                `);

                if (childrenHtml.length >= this.thirdLevelFirstColumnMax) {
                    childrenContainer.push(`
                        <ul class="col-md-6 no-bullet">
                            ${childrenHtml.slice(this.thirdLevelFirstColumnMax, this.thirdLevelFirstColumnMax + this.thirdLevelSecondColumnMax).join("")}
                        </ul>
                    `);
                }

                $(element).append(`
                    <div class="mega-menu-sublist row" mega-menu-sublist="">
                        ${childrenContainer.join("")}
                    </div>
                `);
            }
            children.isSuccessful = true;
        }
        catch(e) {
            children.isSuccessful = false;
            console.error(e);
        }
        finally {
            children.isLoading = false;
            element.classList.remove("is-loading");
            trackInstanciedThirdLevelMenuItem();
        }

    }
}
